import {useQuery} from '@tanstack/react-query'
import {useCallback, useMemo} from 'react'

import {cacheKeys} from 'api'
import {formatCurrency} from 'utils'
import useApi from 'hooks/api/useApi'

const useQuotes = (assetId, queryConfig = null) => {
  const api = useApi()

  const {data: quotes} = useQuery([cacheKeys.assetQuotes], api.getQuotes, queryConfig)
  const assetPrice = useMemo(() => quotes?.[assetId] || 0, [assetId, quotes])

  const calculatePrice = useCallback(
    amount => (amount != null ? amount * assetPrice : 0),
    [assetPrice],
  )

  const getPriceString = useCallback(
    amount => {
      if (amount == null) return '-'
      const price = calculatePrice(amount)
      return `~ ${formatCurrency(price, {
        maximumFractionDigits: price < 0.01 ? 4 : 2,
        currency: 'USD',
      })}`
    },
    [calculatePrice],
  )

  return {quotes, assetPrice, calculatePrice, getPriceString}
}

export default useQuotes
